import React from "react";

interface BankStatementModalProps {
  bankStatementUrl: string;
  userName?: string;
  onClose: () => void;
}

const BankStatementModal: React.FC<BankStatementModalProps> = ({
  bankStatementUrl,
  userName,
  onClose,
}) => {
  return (
    <div className="fixed z-50 inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">
            Bank Statement {userName && `- ${userName}`}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden p-4">
          {bankStatementUrl ? (
            <iframe
              src={bankStatementUrl}
              title="Bank Statement"
              className="w-full h-full border border-gray-300 rounded"
              style={{ minHeight: "500px" }}
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-500">No bank statement available</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-4 border-t border-gray-200">
          {bankStatementUrl && (
            <a
              href={bankStatementUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Open in New Tab
            </a>
          )}
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankStatementModal;

